import $ from 'jquery';
import ISubmitData from '../data/ISubmitData';

export interface IPostResult {
  success: boolean;
  reason?: string;
}

// ================================================================================================
// "private"
// ================================================================================================

// ------------------------------------------------------------------------------------------------
function createFormData(imageBlob: Blob, submitData: ISubmitData): FormData {
  const formData = new FormData();
  formData.append('customerName', submitData.formData.name);
  formData.append('customerEmail', submitData.formData.email);
  formData.append('projectId', submitData.projectId);
  formData.append('mainColor', submitData.mainColor);
  formData.append('secondColor', submitData.secondColor);
  formData.append('thirdColor', submitData.thirdColor);
  formData.append('imageBlob', imageBlob);
  return (formData);
}

// ------------------------------------------------------------------------------------------------
function submitForm(url: string, imageBlob: Blob, submitData: ISubmitData): Promise<IPostResult> {
  const data = createFormData(imageBlob, submitData);
  const promise = new Promise<IPostResult>((resolve, reject) => {
    $.post({
      url,
      data,
      cache: false,
      contentType: false,
      processData: false,

      success: (result: IPostResult) => {
        resolve(result);
      },

      error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
        const msg = `statusText: ${jqXHR.statusText}, message: ${textStatus}, code: ${errorThrown}`;
        reject(new Error(msg));
      },

      dataType: 'json',
    });
  });

  return (promise);
}

// ================================================================================================
// "public"
// ================================================================================================

// ------------------------------------------------------------------------------------------------
export default function submitRequest(url: string,
  canvasImageBlob: Blob, submitData: ISubmitData): Promise<IPostResult> {
  const promise = new Promise<IPostResult>((resolve, reject) => {
    submitForm(url, canvasImageBlob, submitData)
      .then((result) => {
        resolve(result);
      })

      .catch((error: Error) => {
        reject(error);
      });
  });

  return (promise);
}
